import { MotorbikeIcon } from './MotorbikeIcon';

/**
 * author: Google
 * id D6AADAF8-D44E-44C0-8647-E578B277441D
 * name motorbike
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/motorbike.svg
 * tags
 * - Transportation + Road 
 * - Sport 
 */
export const MotorcycleIcon = MotorbikeIcon;
export default MotorcycleIcon